import { Pipe, PipeTransform } from '@angular/core';
import { Web3WalletType } from '../interfaces/auth.interface';

const WalletNameMapping: Partial<Record<Web3WalletType, string>> = {
  [Web3WalletType.MetaMask]: 'MetaMask',
  [Web3WalletType.CoinbaseWallet]: 'Base Wallet',
  [Web3WalletType.TonConnect]: 'TON Connect',
  [Web3WalletType.WalletConnect]: 'WalletConnect',
};

@Pipe({
  name: 'web3WalletName',
  standalone: true,
})
export class Web3WalletNamePipe implements PipeTransform {
  /**
   * Get Web3 wallet name.
   *
   * @param wallet Web3 wallet type
   * @returns The display name of the Web3 wallet
   */
  transform(wallet: Web3WalletType): string {
    return WalletNameMapping[wallet] || 'Web3 Wallet';
  }
}
